'use strict'

import { createSelector } from 'reselect';

export const getMap = ({ places }) => places.byId;
export const getPlaceId = (_, { placeId }) => placeId;

export const getPlace = createSelector(
	[ getMap, getPlaceId ],
	(palces, placeId) => places[ placeId ]
);
